import {call, put, select, takeEvery,} from 'redux-saga/effects';

import {getCompany} from '../sagaUtils';
import {
    FETCH_COMPANY_REQUESTED,
    FETCH_MEMBERS_REQUESTED,
    REMOVE_MEMBERS_REQUESTED,
    UPDATE_COMPANY_REQUESTED,
    UPDATE_MEMBER_REQUESTED,
} from './actionTypes';

import {
    fetchCompanyFailed,
    fetchCompanySucceeded,
    fetchMembersFailed,
    fetchMembersSucceeded,
    removeMembersFailed,
    removeMembersSucceeded,
    updateCompanyFailed,
    updateCompanySucceeded,
    updateMemberFailed,
    updateMemberSucceeded,
} from './action';
import {addNotification} from '../notification/action';

import {
    fetchCompany as fetchCompanyApi,
    fetchCompanyMembers,
    getUserByEmails,
    removeMembers as removeMembersApi,
    updateCompany as updateCompanyApi,
    updateMemberCurrentStatus,
    updateMemberList as updateMemberListApi,
    updateMemberRole2
} from './api';


import config from '../../config';

function* fetchCompany() {
    try {
        const company = yield call(fetchCompanyApi);
        company.subs = company.subs.filter(sub => sub.status !== config.companyStatusMap.deleted);

        let members = yield call(fetchCompanyMembers);
        const emails = members.filter(m => m.status !== 'DELETED').map((member) => member.email);
        const users = yield call(() => getUserByEmails(emails));
        members = members.map((user) => ({...users.find((us) => us.email === user.email), ...user}));
        yield put(fetchCompanySucceeded(Object.assign(company, {
            members,
        })));
    } catch (err) {
        yield put(fetchCompanyFailed());
        yield put(addNotification('cantLoadCompany', config.notificationLevels.error));
    }
}

function* updateCompany(action) {
    try {
        const company = yield select(getCompany);
        yield call(updateCompanyApi, company.id, action.payload.companyUpdate);
        yield put(updateCompanySucceeded(action.payload.companyUpdate));

        yield put(addNotification('companyUpdated', config.notificationLevels.success, {}));
    } catch (err) {
        yield put(updateCompanyFailed());
        yield put(addNotification('failedToUpdateCompany', config.notificationLevels.error, {}));
    }
}

function* fetchMembers() {
    try {
        const members = yield call(fetchCompanyMembers);
        yield put(fetchMembersSucceeded(members));
    } catch (e) {
        yield put(fetchMembersFailed());
    }
}

function* updateMember(action) {
    try {
        if (action.payload.memberUpdate.isStatus) {
            yield call(updateMemberListApi, [action.payload.memberUpdate]);
        }

        if (action.payload.memberUpdate.isCurrentStatus) {
            yield call(updateMemberCurrentStatus, action.payload.memberUpdate)
        }

        if (action.payload.memberUpdate.authorities) {
            yield call(updateMemberRole2, [action.payload.memberUpdate]);
        }

        yield put(updateMemberSucceeded(action.payload.memberUpdate));
        yield put(addNotification('memberUpdated', config.notificationLevels.success, {}));
    } catch (err) {
        yield put(updateMemberFailed());
        yield put(addNotification('memberUpdateFailed', config.notificationLevels.error, {}));
    }
}

function* removeMembers(action) {
    try {
        yield call(removeMembersApi, action.payload.membersList);

        const ids = action.payload.membersList.map((member) => member.id);
        yield put(removeMembersSucceeded(action.payload.membersList));

        yield put(addNotification('memberRemoved', config.notificationLevels.success, {}));
    } catch (err) {
        yield put(removeMembersFailed());
        yield put(addNotification('failedToRemove', config.notificationLevels.error, {}));
    }
}

export default function* watchCompany() {
    yield takeEvery(FETCH_COMPANY_REQUESTED, fetchCompany);
    yield takeEvery(UPDATE_COMPANY_REQUESTED, updateCompany);
    yield takeEvery(FETCH_MEMBERS_REQUESTED, fetchMembers);
    yield takeEvery(UPDATE_MEMBER_REQUESTED, updateMember);
    yield takeEvery(REMOVE_MEMBERS_REQUESTED, removeMembers);
}



// WEBPACK FOOTER //
// ./src/services/company/saga.js